import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { FOOTER_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  footerWrapper: {
    height: `calc(${FOOTER_HEIGHT} - 1px)`,
    borderTop: `1px solid ${theme.palette.border.main}`,
    width: '100%',
    // backgroundColor: theme.palette.background.paper,
    display: 'none',
    // boxShadow: '0px -5px 4px 0px #00000040',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
    zIndex: 1000,
  },
  footerItemsWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '100%',
  },
  footerItemWrapper: {
    flex: 1,
    height: '100%',
    width: '20%',
    maxWidth: '20%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: theme.palette.footer.color,

    // '&:nth-of-type(3) svg': {
    //   height: '40px',
    //   width: '40px',
    // },
  },
  footerItemLink: {
    color: 'unset',
    textDecoration: 'unset',
  },

  footerItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  footerItemButton: {
    borderRadius: '10px',
    minWidth: 'unset',
    position: 'relative',
    paddingTop: theme.spacing(4.5),
    height: '100%',

    svg: {
      color: theme.palette.footer.color,
      position: 'absolute',
      maxWidth: theme.spacing(3),
      maxHeight: theme.spacing(3),
      width: theme.spacing(3),
      height: theme.spacing(3),
      padding: theme.spacing(0.5),
      left: `calc(50% - ${theme.spacing(2)})`,
      borderRadius: '10px',
      top: theme.spacing(1),
    },
    span: {
      color: theme.palette.footer.color,
      opacity: 1,
    },
  },
  mainFooterItemButton: {
    svg: {
      maxWidth: theme.spacing(4),
      maxHeight: theme.spacing(4),
      width: theme.spacing(4),
      height: theme.spacing(4),
      padding: theme.spacing(0.5),
      left: `calc(50% - ${theme.spacing(2.5)})`,
      borderRadius: '10px',
      top: theme.spacing(0.5),
    },
  },

  active: {
    color: theme.palette.footer.activeColor,
    svg: {
      color: theme.palette.footer.activeColor,
      backgroundColor: theme.palette.footer.backgroundActiveColor,
    },
    span: {
      color: theme.palette.footer.activeColor,
    },
  },
  footerItemButtonLabel: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    lineHeight: theme.typography.body2.lineHeight,
    textAlign: theme.typography.body2.textAlign,
    textTransform: theme.typography.body2.textTransform,
    color: theme.palette.footer.color,
  },
}));
